export default "__VITE_ASSET__cf43e631__"